import {withStyles} from '@material-ui/core/styles'
import {ToggleButton} from '@material-ui/lab'

import {theme} from '../theme'

const styles = {
  root: {
    border: '0 none',
    padding: theme.spacing(2) - 2,
    flex: 1,
    '&$selected': {
      boxShadow: '0 8px 20px rgba(117, 115, 111, 0.2)',
      backgroundColor: theme.palette.common.white,
      color: theme.palette.secondary.main,
    },
  },
  selected: {},
}

export default withStyles(styles, {name: 'LPCToggleButton'})(ToggleButton)
